import {
  Button,
  Grid,
  GridChild,
  Heading,
  Typography,
} from '@norges-domstoler/dds-components';

import { Page } from '../shared/Page/Page';
import { useTranslation } from 'react-i18next';

export function LoginErrorPage() {
  const { t } = useTranslation();

  return (
    <Page>
      <Grid as="div">
        <GridChild columnsOccupied="all">
          <Heading level={2}>{t('login.error.page.heading')}</Heading>

          <div className="mb-4">
            <Typography typographyType="body-short-small">
              {t('login.error.page.info')}
            </Typography>
          </div>

          <form method="post" action="/bff/signout" aria-hidden="true">
            <Button type="submit" purpose="secondary">
              {t('login.error.page.button.label')}
            </Button>
          </form>
        </GridChild>
      </Grid>
    </Page>
  );
}
